// src/components/RideDetailsFormMUI.jsx
import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  ToggleButton,
  Paper,
  TextField,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

//import { useBookingDispatch } from './BookingContext'
import { AirportToggle } from "./StyledToggles";
import AddressInputs from "./AddressInputs";
// import { useBookingState } from './BookingContext'
import { useBookingDispatch, useBookingState } from "./BookingContext";
import { useEffect } from "react";
import "./RideDetailsForm.css";

export default function RideDetailsFormMUI() {
  const dispatch = useBookingDispatch();
  const {
    rideType,
    terminal,
    mode: ctxMode,
    pickup: ctxPickup,
    dropOff: ctxDropOff,
    when: ctxWhen,
    dateTime: ctxDateTime,
    returnDateTime: ctxReturnDateTime,
    name: ctxName,
    phone: ctxPhone,
    email: ctxEmail,
    selectedPackage: ctxRentalPackage,
    airportDirection: ctxAirportDirection,
    pickupCoordinates: ctxPickupCoordinates,
    dropOffCoordinates: ctxDropOffCoordinates,
  } = useBookingState();
  const isTerminal = (value) => /^Terminal\s+\d+/i.test(value);
  //const { rideType } = useBookingState()
  console.log("rideType-----", rideType);
  //const terminal = '01'
  const isOutstation = rideType === "outstation";
  // const { terminal, terminalLocation } = useBookingState()

  // local form state
  // const [mode, setMode]         = useState('pickup')
  const [mode, setMode] = useState(() => ctxMode || "pickup");
  const isRoundTrip = isOutstation && mode === "drop";
  const isOneWay = isOutstation && mode === "pickup";
  const rentalPackages = [
    "2 hrs 20 kms",
    "4 hrs 40 kms",
    "6 hrs 60 kms",
    "8 hrs 80 kms",
    "12 hrs 120 kms",
  ];
  const TERMINAL_COORDS = {
    "01": [77.70700442672575, 13.201605323686568], // Terminal 1
    "02": [77.71480215307044, 13.199327817300741], // Terminal 2
  };
  //const [selectedPackage, setSelectedPackage] = useState('');
  const [selectedPackage, setSelectedPackage] = useState(
    () => ctxRentalPackage || ""
  );
  // const [pickup, setPickup] = useState(
  //   rideType === 'airport' ? `Terminal ${terminal}` : ''
  // );
  const [pickup, setPickup] = useState(
    () => ctxPickup || (rideType === "airport" ? `Terminal ${terminal}` : "")
  );
  // const [pickupCoordinates, setPickupCoordinates] = useState(
  //   rideType === 'airport' && TERMINAL_COORDS[terminal] ? TERMINAL_COORDS[terminal] : [0, 0]
  // );
  const [pickupCoordinates, setPickupCoordinates] = useState(() =>
    ctxPickupCoordinates?.length
      ? ctxPickupCoordinates
      : rideType === "airport" && TERMINAL_COORDS[terminal]
      ? TERMINAL_COORDS[terminal]
      : [0, 0]
  );
  //const [dropOff, setDropOff]   = useState('')
  const [dropOff, setDropOff] = useState(() => ctxDropOff || "");
  //const [when, setWhen]         = useState('now')
  const [when, setWhen] = useState(() => ctxWhen || "now");
  //const [dateTime, setDateTime] = useState(new Date())
  const [dateTime, setDateTime] = useState(() =>
    ctxDateTime ? new Date(ctxDateTime) : new Date()
  );

  // const [name, setName]         = useState('')
  const [name, setName] = useState(() => ctxName || "");
  //const [phone, setPhone]       = useState('')
  const [phone, setPhone] = useState(() => ctxPhone || "");
  const [touched, setTouched] = useState(false); // to avoid red error on first load
  const isValidPhone = /^[6-9]\d{9}$/.test(phone);
  //const [returnDateTime, setReturnDateTime] = useState(new Date());
  const [returnDateTime, setReturnDateTime] = useState(() =>
    ctxReturnDateTime ? new Date(ctxReturnDateTime) : new Date()
  );
  const [editingField, setEditingField] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  // const [dropOffCoordinates, setDropOffCoordinates] = useState([0, 0]);
  const [dropOffCoordinates, setDropOffCoordinates] = useState(() =>
    ctxDropOffCoordinates?.length ? ctxDropOffCoordinates : [0, 0]
  );
  const [email, setEmail] = useState(() => ctxEmail || "");
  //const [airportDirection, setAirportDirection] = useState('from');
  const [airportDirection, setAirportDirection] = useState(
    () => ctxAirportDirection ?? (mode === "pickup" ? "from" : "to")
  );
  const formValid =
    Boolean(pickup.trim()) &&
    (rideType === "rental"
      ? Boolean(selectedPackage)
      : Boolean(dropOff.trim())) &&
    Boolean(name.trim()) &&
    Boolean(phone.trim()) &&
    isValidPhone;

  useEffect(() => {
    if (when === "now") {
      const now = new Date();
      setDateTime(now);

      // If you also want the return leg to reset for round-trips, uncomment:
      // if (isOutstation && isRoundTrip) setReturnDateTime(now);
    }
  }, [when]);
  useEffect(() => {
    if (rideType === "airport") {
      setAirportDirection(mode === "pickup" ? "from" : "to");
    }
  }, [mode, rideType]);

    useEffect(() => {
    if (rideType !== "airport") return;

    const label = `Terminal ${terminal}`;
    const coords = TERMINAL_COORDS[terminal] || [0, 0];

    if (mode === "pickup") {
      // Airport pickup: prefill pickup, clear dropOff
      setPickup(label);
      setPickupCoordinates(coords);
      setDropOff("");
      setDropOffCoordinates([0, 0]);
    } else {
      // Airport drop-off: prefill dropOff, clear pickup
      setDropOff(label);
      setDropOffCoordinates(coords);
      setPickup("");
      setPickupCoordinates([0, 0]);
    }
  }, [rideType, mode, terminal]);

  function handleSubmit() {
    if (!formValid) return;
    // save everything into context and go to review
    dispatch({
      type: "SAVE_DETAILS",
      payload: {
        mode,
        pickup,
        dropOff,
        pickupCoordinates,
        dropOffCoordinates,
        airportDirection,
        when,
        dateTime,
        returnDateTime,
        departureDateTime: rideType === "outstation" ? dateTime : undefined,
        rentalPackage: selectedPackage,
        tripType:
          rideType === "outstation"
            ? mode === "drop"
              ? "roundTrip"
              : "oneWay"
            : "",
        rideOption: when === "now" ? "rideNow" : "rideLater",
        name,
        phone,
        email,
      },
    });
  }

  useEffect(() => {
    if (rideType !== "airport" || !TERMINAL_COORDS[terminal]) return;

    const terminalLabel = `Terminal ${terminal}`;
    const terminalCoords = TERMINAL_COORDS[terminal];

    const isPickupEmpty = !pickup.trim();
    const isDropOffEmpty = !dropOff.trim();

    if (isPickupEmpty && isDropOffEmpty) {
      // Default fallback — set pickup by default
      setPickup(terminalLabel);
      setPickupCoordinates(terminalCoords);
    } else if (mode === "pickup") {
      if (isPickupEmpty) {
        // unchanged
      } else {
        const pickupIsTerminal = isTerminal(pickup);
        const dropIsTerminal = isTerminal(dropOff);

        // Swap ONLY if the fields are inverted for this mode
        if (!pickupIsTerminal && dropIsTerminal) {
          const tmpLoc = pickup;
          const tmpCoor = pickupCoordinates;
          setPickup(dropOff);
          setPickupCoordinates(dropOffCoordinates);
          setDropOff(tmpLoc);
          setDropOffCoordinates(tmpCoor);
        }
      }
    } else if (mode === "drop") {
      if (isDropOffEmpty) {
        // unchanged
      } else {
        const pickupIsTerminal = isTerminal(pickup);
        const dropIsTerminal = isTerminal(dropOff);

        if (pickupIsTerminal && !dropIsTerminal) {
          const tmpLoc = pickup;
          const tmpCoor = pickupCoordinates;
          setPickup(dropOff);
          setPickupCoordinates(dropOffCoordinates);
          setDropOff(tmpLoc);
          setDropOffCoordinates(tmpCoor);
        }
      }
    }
    // else if (mode === 'pickup') {
    //   if (isPickupEmpty) {
    //     setPickup(terminalLabel);
    //     setPickupCoordinates(terminalCoords);
    //     setDropOff('');
    //     setDropOffCoordinates([0, 0]);
    //   } else if (!isPickupEmpty && !isDropOffEmpty) {
    //     // Swap if both filled
    //     const tempLocation = pickup;
    //     const tempCoords = pickupCoordinates;
    //     setPickup(dropOff);
    //     setPickupCoordinates(dropOffCoordinates);
    //     setDropOff(tempLocation);
    //     setDropOffCoordinates(tempCoords);
    //   }
    // } else if (mode === 'drop') {
    //   if (isDropOffEmpty) {
    //     setDropOff(terminalLabel);
    //     setDropOffCoordinates(terminalCoords);
    //     setPickup('');
    //     setPickupCoordinates([0, 0]);
    //   } else if (!isPickupEmpty && !isDropOffEmpty) {
    //     // Swap if both filled
    //     const tempLocation = pickup;
    //     const tempCoords = pickupCoordinates;
    //     setPickup(dropOff);
    //     setPickupCoordinates(dropOffCoordinates);
    //     setDropOff(tempLocation);
    //     setDropOffCoordinates(tempCoords);
    //   }
    // }
  }, [mode, terminal, rideType]);

  // layout wrapper
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: 600,
        px: 0,
        my: 1,
        maxWidth: 400,
        mx: "auto",
      }}
    >
      {/* --- Address Layout --- */}
      <AnimatePresence>
        {editingField && (
          <motion.div
            key="address-edit"
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 300, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            style={{
              position: "absolute",
              width: "100%",
              zIndex: 2,
              top: 0,
            }}
          >
            <AddressInputs
              rideType={rideType}
              mode={mode}
              terminal={terminal}
              pickup={pickup}
              dropOff={dropOff}
              editingField={editingField}
              onRowClick={setEditingField}
              onFieldSelect={(field, val, coordinates) => {
                if (field === "pickup") {
                  setPickup(val);
                  setPickupCoordinates(coordinates || [0, 0]);
                } else {
                  setDropOff(val);
                  setDropOffCoordinates(coordinates || [0, 0]);
                }

                const nextPickup = field === "pickup" ? val : pickup;
                const nextDropOff = field === "dropOff" ? val : dropOff;

                const isOutstationOrLocal =
                  rideType === "outstation" || rideType === "intracity";
                const bothFilled = nextPickup.trim() && nextDropOff.trim();

                if (isOutstationOrLocal && !bothFilled) return;

                setEditingField(null);
              }}
              onPickupChange={setPickup}
              onDropOffChange={setDropOff}
              onCancel={() => setEditingField(null)}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* --- Main Form Layout --- */}
      <AnimatePresence>
        {!editingField && (
          <motion.div
            key="main-form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            style={{
              position: "relative",
              zIndex: 1,
            }}
          >
            <Typography
              align="center"
              sx={{ mt: 2, mb: 2, fontWeight: 700, fontSize: "18px" }}
            >
              Enter your ride details
            </Typography>

            {rideType === "airport" && (
              <AirportToggle
                value={mode}
                exclusive
                onChange={(_, v) => v && setMode(v)}
              >
                <ToggleButton value="pickup">Pickup from airport</ToggleButton>
                <ToggleButton value="drop">Drop to airport</ToggleButton>
              </AirportToggle>
            )}

            {isOutstation && (
              <AirportToggle
                value={mode}
                exclusive
                onChange={(_, v) => v && setMode(v)}
                sx={{ mt: 2, mb: 2 }}
              >
                <ToggleButton value="pickup">One Way</ToggleButton>
                <ToggleButton value="drop">Round Trip</ToggleButton>
              </AirportToggle>
            )}

            <AddressInputs
              rideType={rideType}
              mode={mode}
              terminal={terminal}
              pickup={pickup}
              dropOff={dropOff}
              editingField={null}
              onRowClick={(f) => setEditingField(f)}
              onPickupChange={setPickup}
              onDropOffChange={setDropOff}
            />

            {rideType === "rental" && (
              <Paper className="plan-card" elevation={1} sx={{ pb: 2, px: 2 }}>
                <Typography className="select-rental" sx={{ mb: 1 , mt:1}}>
                  Select a rental package
                </Typography>
                <TextField
                  select
                  fullWidth
                  variant="filled"
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e.target.value)}
                  InputProps={{
                    disableUnderline: true,
                    sx: { backgroundColor: "#E6FFF8", borderRadius: 2 },
                    inputProps: {
                      style: {
                        padding: "14px 16px",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                  SelectProps={{ native: true }}
                >
                  <option value="" disabled>
                    Select your package
                  </option>
                  {rentalPackages.map((pkg, idx) => (
                    <option key={idx} value={pkg}>
                      {pkg}
                    </option>
                  ))}
                </TextField>
              </Paper>
            )}

            <Paper
              className="plan-card"
              elevation={1}
              sx={{ pb: when === "later" ? 3 : 0 }}
            >
              <AirportToggle
                value={when}
                exclusive
                onChange={(_, v) => v && setWhen(v)}
              >
                <ToggleButton value="now">
                  {/* <FlashOnIcon fontSize="small" sx={{ mr:1 }} /> Go Now */}
                  <img
                    src="/icons/ride_now.svg"
                    alt="Ride now"
                    style={{ marginRight: 8 }}
                  />
                  Go Now
                </ToggleButton>
                <ToggleButton value="later">
                  {/* <AccessTimeIcon fontSize="small" sx={{ mr:1 }} /> Plan ahead */}
                  <img
                    src="/icons/ride_later.svg"
                    alt="Plan ahead"
                    style={{ width: 16, height: 16, marginRight: 12 }}
                  />
                  Plan ahead
                </ToggleButton>
              </AirportToggle>

              {(() => {
                if (isOutstation && isRoundTrip && when === "later") {
                  // 🟡 Outstation Round Trip + Later → show 2 calendars
                  return (
                    <>
                      <Typography className="plan-subtitle">
                        Choose your pick-up date and time.
                      </Typography>

                      <Box
                        className="plan-pill"
                        onClick={() => setPickerOpen("pickup")}
                      >
                        <Typography className="pill-text">
                          {format(dateTime, "dd MMM yyyy 'at' hh:mm a")}
                        </Typography>
                        <CalendarTodayIcon className="pill-icon" />
                      </Box>

                      <Typography className="plan-subtitle">
                        Choose your return date and time.
                      </Typography>

                      <Box
                        className="plan-pill"
                        onClick={() => setPickerOpen("return")}
                      >
                        <Typography className="pill-text">
                          {format(returnDateTime, "dd MMM yyyy 'at' hh:mm a")}
                        </Typography>
                        <CalendarTodayIcon className="pill-icon" />
                      </Box>
                    </>
                  );
                }

                if (isOutstation && isRoundTrip && when === "now") {
                  // 🟢 Outstation Round Trip + Now
                  return (
                    <>
                      <Typography className="plan-subtitle">
                        Choose your return date and time.
                      </Typography>
                      <Box
                        className="plan-pill"
                        onClick={() => setPickerOpen("return")}
                      >
                        <Typography className="pill-text">
                          {format(returnDateTime, "dd MMM yyyy 'at' hh:mm a")}
                        </Typography>
                        <CalendarTodayIcon className="pill-icon" />
                      </Box>
                      <Box sx={{ height: 16 }} />
                    </>
                  );
                }

                if (
                  (isOutstation && isOneWay && when === "later") ||
                  (!isOutstation && when === "later")
                ) {
                  // 🔵 One Way Later OR Airport/Rental/Local Later → current logic
                  return (
                    <>
                      <Typography className="plan-subtitle">
                        Choose your pick-up date and time.
                      </Typography>
                      <Box
                        className="plan-pill"
                        onClick={() => setPickerOpen("pickup")}
                      >
                        <Typography className="pill-text">
                          {format(dateTime, "dd MMM yyyy 'at' hh:mm a")}
                        </Typography>
                        <CalendarTodayIcon className="pill-icon" />
                      </Box>
                    </>
                  );
                }

                return null;
              })()}

              {/* 
              {when==='later' && (
                <>
                  <Typography className="plan-subtitle">
                    Pick a date and time that works best for you.
                  </Typography>
                  <Box
                    className="plan-pill"
                    onClick={() => setPickerOpen(true)}
                  >
                    <Typography className="pill-text">
                      {format(dateTime, "dd MMM yyyy 'at' hh:mm a")}
                    </Typography>
                    <CalendarTodayIcon className="pill-icon" />
                  </Box>
                </>
              )} */}
            </Paper>

            <Paper className="rider-card" elevation={1}>
              <Box textAlign="center">
                <Typography className="rider-title">
                  Who’s riding today?
                </Typography>
                <Typography className="rider-subtitle">
                  A quick call or text helps the driver find you faster.
                </Typography>
              </Box>
              <TextField
                fullWidth
                variant="filled"
                placeholder="What should the driver call you?"
                value={name}
                onChange={(e) => setName(e.target.value)}
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    backgroundColor: "#E8FFF7",
                    borderRadius: 2,
                    mt: 3,
                    mb: 3,
                    color: "#000000",
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "17px",
                  },
                }}
                inputProps={{
                  style: {
                    padding: "16px 16px",
                    textAlign: "left",
                    color: "#000000",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input::placeholder": {
                    color: "#000000",
                    opacity: 0.6,
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "17px",
                  },
                }}
              />

              <TextField
                fullWidth
                variant="filled"
                placeholder="Best number to reach you on"
                value={phone}
                error={touched && !isValidPhone}
                helperText={
                  touched && !isValidPhone
                    ? "Enter a valid 10-digit mobile﻿ number"
                    : " "
                }
                onChange={(e) => {
                  // keep only digits, limit to 10
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setPhone(digits);
                }}
                onBlur={() => setTouched(true)}
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    backgroundColor: "#E8FFF7",
                    borderRadius: 2,
                    color: "#000000",
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "17px",
                  },
                }}
                inputProps={{
                  inputMode: "numeric", // mobile keyboard with digits
                  style: {
                    padding: "16px 16px",
                    textAlign: "left",
                    color: "#000000",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input::placeholder": {
                    color: "#000000",
                    opacity: 0.6,
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "17px",
                  },
                }}
              />

              {/* <TextField
  fullWidth
  variant="filled"
  type="tel"
  placeholder="Best number to reach you on"
  value={phone}
  onChange={(e) => setPhone(e.target.value)}
  InputProps={{
    disableUnderline: true,
    sx: {
      backgroundColor: '#E8FFF7',
      borderRadius: 2,
      color: '#000000',
      fontFamily: 'Lato',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
    },
  }}
  inputProps={{
    style: {
      padding: '12px 16px',
      textAlign: 'left',
      color: '#000000',
    }
  }}
  sx={{
    '& .MuiInputBase-input::placeholder': {
      color: '#000000',
      opacity: 0.6,
      fontFamily: 'Lato',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
    }
  }}

/> */}
            </Paper>

            <Button
              fullWidth
              disabled={!formValid}
              onClick={handleSubmit}
              sx={{
                mt: 2,
                height: "56px", 
                backgroundColor: "#A1F0D7",
                color: "#000000", // from font color in spec
                textTransform: "none", // use normal case instead of uppercase
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: "17px",
                borderRadius: "36px",
                // py: 1.5,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#94D9C1",
                  boxShadow: "none",
                },
              }}
            >
              REVIEW YOUR BOOKING
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
      <div style={{ display: "none" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {/* <DateTimePicker
            open={pickerOpen}
            onClose={() => setPickerOpen(false)}
            value={dateTime}
            onChange={setDateTime}
          /> */}
          <DateTimePicker
            open={pickerOpen === "pickup"}
            onClose={() => setPickerOpen(false)}
            value={dateTime}
            onChange={setDateTime}
          />
          <DateTimePicker
            open={pickerOpen === "return"}
            onClose={() => setPickerOpen(false)}
            value={returnDateTime}
            onChange={setReturnDateTime}
          />
        </LocalizationProvider>
      </div>
    </Box>
  );
}
